import { render, staticRenderFns } from "./AddNewService.vue?vue&type=template&id=4e7a8918&scoped=true&"
import script from "./AddNewService.vue?vue&type=script&lang=js&"
export * from "./AddNewService.vue?vue&type=script&lang=js&"
import style0 from "./AddNewService.vue?vue&type=style&index=0&id=4e7a8918&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7a8918",
  null
  
)

export default component.exports